const readMoreInit = (block) => {
    const textBlocks = block?.[0] && block[0].querySelector(".bn-text__content") ? block[0].querySelector(".bn-text__content") : document.querySelector(".bn-text__content") ? Array.from(document.querySelectorAll(".bn-text__content")) : [];

    if(textBlocks.length > 0) {
        textBlocks.forEach(textBlock => {
            const readMoreButton = textBlock.parentNode.querySelector('.bn-text__button');

            readMoreButton.addEventListener('click', () => {
                textBlock.classList.toggle('--expanded');
                let innerText = readMoreButton.innerText;
                readMoreButton.textContent = readMoreButton.dataset.label;
                readMoreButton.dataset.label = innerText;
            });
        });
    }
};

document.addEventListener("DOMContentLoaded", function () {
    if (document.body && !document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body')) {
        readMoreInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/text', readMoreInit);
    }
});